export const TITLE = "ui.head.title";

export const PROGRAMS_TITLE = "ui.head.programs_title";
